import { servicesApi } from '@/services/api/deprecated';
import { getSetupGuide, updateSetupGuide } from '../setup-guide/api';
import { getWorkspaceIdFromCurrentUrl } from '@/context/current-workspace';
import { AxiosError } from 'axios';

// Attempts to get the sample campaign, and resets the ID if none is found
export const getSampleCampaign = async () => {
  const workspaceId = getWorkspaceIdFromCurrentUrl();
  const setupGuide = await getSetupGuide(workspaceId);
  const sampleCampaignId = setupGuide?.setup_guide.sample_campaign_id;

  if (isNaN(parseInt(String(workspaceId))) || isNaN(parseInt(String(sampleCampaignId)))) {
    return null;
  }

  try {
    const { data } = await servicesApi.get(`/environments/${workspaceId}/campaigns/${sampleCampaignId}`);
    return data;
  } catch (error: unknown) {
    if (error instanceof AxiosError && error.response?.status === 404) {
      updateSetupGuide(workspaceId as number, {
        ...setupGuide?.setup_guide,
        sample_campaign_id: undefined,
      });
    }
  }
};
